module.exports = __webpack_public_path__ + "img/check.e1cbbc25.svg";